import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 270 270"
      height={props.height}
      className={props.svgClass}
    >
      <path
        className={props.pathClass ? props.pathClass : "black"}
        d="M16059.5 2426.21c1-2.75 3.7-4.58 6.6-4.58 2.9 0 5.6 1.83 6.6 4.58 15.5 42.48 54.4 148.64 68.8 187.92 1 2.6.3 5.51-1.7 7.42-2 1.92-5 2.46-7.5 1.4-23.3-9.66-66.2-27.41-66.2-27.41s-42.9 17.75-66.2 27.41c-2.6 1.06-5.5.52-7.5-1.4-2-1.91-2.7-4.82-1.8-7.42 14.4-39.28 53.4-145.44 68.9-187.92z"
        transform="matrix(0 1.33008 -1.33558 0 3503.87 -21234.2)"
      ></path>
    </svg>
  );
}

export default Icon;
